<template>
  <div v-if="info && info.length" style="position: relative; width: 100%; height: 100%;">
    <p style="position: relative; width: 100%; text-align: center; padding: 0; margin: 0">Percentage Distribution By Version</p>
    <div style="height: 120%; margin-left: 25px">
      <canvas id="firmareversionpiechart"></canvas> 
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default { 
  props: {
    info: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      chart: false
    }
  },

  mounted () {
   this.buildChart()
  },

  watch: {
    info() {
      this.$nextTick(() => {
        this.buildChart()
      })
    }
  },

  computed: {
    // chart data
    chartData () {
      let chartData = []
      let remainder = 0
      let total = 0

      for(let x = 0; x < this.info.length; x++) {
        total += this.info[x].device_count
        if(x < 5) {
          chartData.push(this.info[x])
        } else {
          remainder += this.info[x].device_count
        }
      }

      chartData.push({
        fw_version: 'Others',
        device_count: remainder
      })
      
      return chartData.map(i => {
        return {
          fw_version: i.fw_version,
          device_count: Number.parseInt((i.device_count / total) * 100)
        }
      })
      /*
      return this.info.reduce((set, item) => {
        set[item.fw_version] = item.device_count
        return set
      }, {})
      */
    }
  },

  methods: {
    buildChart () {
      const labels = this.chartData.map(i => i.fw_version)

      const data = {
        labels: labels,
        datasets: [
          {
            label: 'Device count',
            data: this.chartData.map(i => i.device_count),
            backgroundColor: ['#a02b93', '#e97132', '#a6caec', '#ffc000', '#4ea72e', '#0f9ed5'],
            hoverOffset: 4,
            callback: function(value) {
              return `${value}%`
            }
          }
        ]
      }

      const config = {
        height: '400px',
        responsive: false,
        plugins: {
          datalabels: {
            color: 'black',
            display: 'auto',
            formatter: function(value) {
              return `${value}%`
            }
          },
          legend: {
            position: 'right',
            labels: {
              color: 'rgba(0,0,0,0.6)'
            }
          }
        }
      }

      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(
      document.getElementById('firmareversionpiechart'), {
        type: 'pie', 
        plugins: [ChartDataLabels],
        data: data,
        options: config
      })
    }
  }
}
</script>